import type { EdgeTypes } from '@xyflow/react';
import BranchedEdge from './BranchedEdge';

/**
 * Single registered edge type — every process edge uses the branched
 * renderer so its stroke colour adapts to which gate branch it leaves from.
 */
export const edgeTypes: EdgeTypes = {
  branched: BranchedEdge,
};
